// extracted by mini-css-extract-plugin
export default {"container":"OtpInput_container__PtRxI","input":"OtpInput_input__DYyWx","error":"OtpInput_error__ZTj4V","disabled":"OtpInput_disabled__VorTf"};